import style from "styled-components";

export const SearchContainer = style.form`
   transform: ${({ open }) => (open ? "translateY(1px)" : "translateY(2px)")};
    background-color: white;
    display: ${({ open }) => (open ? "flex" : "none")};
    flex-direction: row;
    min-height: 100px;
    border-top:1px solid black;
    border-bottom:1px solid black;
    margin-bottom:10px;
    transition: all 0.45s ease-out;
    justify-content: space-around;
    align-items: center;
`;

export const SearchContainerImage = style.img`
width: 20px;
`;

export const SearchContainerInput = style.input`
border: none;
    height: 20px;
    width: 80%;
    &:focus{
        outline:none;
    }
`;
